import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {
    FlyerPageSpotDto,
    PromoDto,
    PromoItemsDto,
    SaleTypeDto, SelectPageForTabsDto,
    SellingUnitDto,
} from "../../../../../../../dtos";
import styles from "./PromotionDetailsModalPopup.module.scss";
import {ReactComponent as Calendar} from "../../../../../../../assets/promos&items/calendar_icon.svg";
import DatePicker from "react-datepicker";
import {ReactComponent as DropdownIcon} from "../../../../../../../assets/flyerDetailsPopupAssets/dropdown.svg";
import "react-datepicker/dist/react-datepicker.css";
import Select, {components, Theme} from "react-select";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {PageSpinner} from "../../../../../../com/pagesTab/pagesSpinner/spinner";
import {OrangeButton} from "../../../../../../com/pagesTab/orangeBtn/OrangeButton";
import {useDispatch} from "react-redux";
import {PromosSaleTypesPopup} from "../../../../../../com/PromosSaleTypesPopup/PromosSaleTypesPopup";
import {
    convertGenericPromoParamsToProperties, convertPromoPropertiesToGenericParams,
    getPromoSaleTypeCaptions
} from "../../../../../../../globals/PromoSaleTypeCaptionGenerator";
import {
    createPromotion,
    deleteImageFromPromotion,
    updatePromotion
} from "../../../../../../../store/actionCreators/promotionsItemsCreators";
import {saleTypesDropdownData} from "../../../../../../../globals/Contants";
import {getFlippingFlyer} from "../../../../../../../store";
import {Box, Button, createTheme, ThemeProvider} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {ImagePreviewPopup} from "../../../../../../com/tooltipPreviewOnlyImage/imagePreview";
import {AsyncImageWithLoader} from "../../../../../../../com/imageWithLoader/imageWithLoader";
import {FileInput} from "../../../../../../com/FileInput/FileInput";
import {ReactComponent as UploadImageIcon} from "../../../../../../../assets/promos&items/upload_icon.svg";
import {ReactComponent as DeleteImageIcon} from "../../../../../../../assets/promos&items/delete_icon.svg";
import {makeStyles} from "@mui/styles";
import {SimpleConfirmPopup} from "../../../../../../../com/simpleConfirmPopup/SimpleConfirmPopup";
import {ClosePopupBtn} from "../../../../../../../com/closePopupBtn/closePopupBtn";
import _ from 'lodash'
import {NonImagePlaceholder} from "../../../../../../com/nonImagePlaceholder/nonImagePlaceholder";

const useStyles = makeStyles(() => ({
    imagesButton: {
        '&.MuiButton-root': {
            cursor: `pointer`,
            margin: `0 8px`,
            display: `flex`,
        },
        '&.Mui-disabled': {
            opacity: `0.5`
        }
    }
}))

const theme = createTheme({
    components: {
        // Name of the component
        MuiTooltip: {
            styleOverrides: {
                // Name of the slot
                tooltip: {
                    // Some CSS
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    maxWidth: '620px',
                    width: '620px',
                    maxHeight: '620px',
                    border: '1px solid #4D4D4D',
                    borderRadius: '5px',
                },
                popper: {
                    zIndex: 1501
                }
            },
        },
    },
});


const customStyles = {
    control: (base: any) => ({
        ...base,
        boxShadow: "none",
        height: "35px",
        border: "1px solid #888888",
        fontWeight: "normal",
        textAlign: "start",
        lineHeight: 1,
        width: '100%',
        // padding: '0 0 0 10px',
        fontSize: '16px',
        cursor: "pointer",
        ":hover": {
            borderColor: "#888888",
        },
    }),

    singleValue: (base: any) => ({
        ...base,
        lineHeight: "20px",
        top: `46%`,
        fontSize: `16px`,
        padding: `0 5px`
    }),
    valueContainer: (base: any) => ({
        ...base,
        // height: "14px",
        padding: "0",
        fontSize: "16px",
    }),
    input: (base: any) => ({
        ...base,
        padding: '0',
        fontSize: "16px",
        height: "16px",
        width: 0
    }),
    menuList: (base: any) => ({
        ...base,
        fontWeight: "normal",
        padding: '0'
    }),
    option: (base: any) => ({
        ...base,
        padding: '5px',
        lineHeight: '1',
        margin: '0',
        textAlign: `initial`
    })
};

const themeSelect = (theme: Theme) => ({
    ...theme,
    spacing: {
        ...theme.spacing,
        controlHeight: 35,
        // baseUnit: 0,
    }
});

const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <DropdownIcon/>
        </components.DropdownIndicator>
    );
};


interface ErrorsForField {
    isEmptyPromotionCaption: boolean;
    isEmptyPromotionCode: boolean;
    // isEmptyPromotionSaleType: boolean;
}


interface Props {
    isShow: boolean;
    isNewPromotion: boolean;
    promotionData: PromoDto;
    openPromotionModalPopup: (isOpen: boolean) => void;
    isHebrew: boolean;
    currencySymbol: string;
    frameData?: FlyerPageSpotDto;
    isUnlinked: boolean;
}


export const PromotionDetailsModalPopup: React.FC<Props> = (
    {
        isShow,
        isNewPromotion,
        promotionData,
        openPromotionModalPopup,
        isHebrew,
        currencySymbol,
        frameData,
        isUnlinked
    }
) => {
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const saleTypes = useTypedSelector((state) => state.saleTypes.saleTypesForSpecificFlyer);
    const sellingUnitsForFlyer = useTypedSelector((state) => state.sellingUnits.sellingUnitsForFlyer);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let selectedPagesForTabState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const selectedPageImage = flyerDetailsState.flyerPages[selectedPagesForTabState.pageNo === 0 ? 0 : selectedPagesForTabState.pageNo - 1].flpImageUrl;

    // let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const dispatch = useDispatch();
    //promotions state
    const [defaultPromotionState, setDefaultPromotionState] = useState<PromoDto>({});
    const [promotionState, setPromotionState] = useState<PromoDto>({});
    //errors state
    const [emptyFields, setEmptyFields] = useState<ErrorsForField>({
        isEmptyPromotionCaption: false,
        isEmptyPromotionCode: false,
        // isEmptyPromotionSaleType: false,
    })
    // promotion caption state
    const [convertedPromoCaption, setPromoCaption] = useState<string>('');
    //date picker range states
    const [dateRange, setDateRange] = useState<any>([null, null]);
    const [startDate, endDate] = dateRange;

    //loader state
    const [isLoading, setLoadingWrapper] = useState<boolean>(false);

    //saletypes dropdownState
    const [isSaleTypesDropdownOpen, openSaleTypesDropdown] = useState<boolean>(false);

    //sale type selected data
    const [selectedSaleType, setSelectedSaleType] = useState<SaleTypeDto>({});

    const [selectedSellingUnit, setSelectedSellingUnit] = useState<SellingUnitDto>({})
    const [sellingUnitsState, setSellingUnitsState] = useState<any>([]);

    const [imageSrcState, setImageSrcState] = useState<string>(``);
    const [selectedImageFile, setImageFile] = useState<File | null>();
    // const [withTooltip, showTooltip] = useState<boolean>(true);
    // const [imageSelectionNumber, setImageSelectionNumber] = useState<number>(3);

    //confirm popups
    const [isShowConfirmExitPopup, setShowConfirmExitPopup] = useState(false);
    const [isRequiredFieldsNotFilled, setIsRequiredFieldsNotFilled] = useState<boolean>(false);
    const properties = {
        isHebrew: isHebrew
    }
    const classes = useStyles(properties);

    useEffect(() => {
        const newSellingUnitFromChangedSellingUnitsArray = sellingUnitsState.find((sellingUnit: any) => selectedSellingUnit.id === sellingUnit.id);
        if (newSellingUnitFromChangedSellingUnitsArray && newSellingUnitFromChangedSellingUnitsArray.disabled) {
            const notDisabledSellingUnitsArray = sellingUnitsState.filter((sellingUnit: any) => !sellingUnit.disabled);
            if (notDisabledSellingUnitsArray.length) {
                setSelectedSellingUnit(notDisabledSellingUnitsArray[0]);
            }
        }
    }, [sellingUnitsState])

    useEffect(() => {
        if (selectedImageFile) {
            let newSrc = URL.createObjectURL(selectedImageFile);
            setImageSrcState(newSrc);
            // promo.imageSelection = 3 (If there is a Promo Image, display it. If not, display the Frame Image)
            setPromotionState({
                ...promotionState,
                flrImage: newSrc,
                imageSelection: 3
            })
            // setImageSelectionNumber(3);
            // showTooltip(true);
        }

    }, [selectedImageFile])


    //set promotion states
    useEffect(() => {
        try {
            const selectedSellingUnit = sellingUnitsForFlyer?.find((sellingUnit: SellingUnitDto) => {
                if (sellingUnit.id === promotionData.flrSeuRecId) {
                    return sellingUnit;
                }
            })
            setSelectedSellingUnit(selectedSellingUnit ?
                {
                    ...selectedSellingUnit,
                    value: selectedSellingUnit.code,
                    label: selectedSellingUnit.languageCaption,
                    disabled: true
                } :
                {
                    ...sellingUnitsForFlyer![0],
                    value: sellingUnitsForFlyer![0].code,
                    label: sellingUnitsForFlyer![0].languageCaption,
                }
            );
            const sellingUnitsForFlyerWithDisabledOption = sellingUnitsForFlyer?.map((sellingUnit: SellingUnitDto) => {
                return {
                    ...sellingUnit,
                    disabled: promotionData.flrSatCode !== 70 && (sellingUnit.id !== 23 && sellingUnit.id !== 1 && sellingUnit.id !== 8)
                }
            })
            setSellingUnitsState(sellingUnitsForFlyerWithDisabledOption);
        } catch (err) {
            console.log(`missing selling units array`);
        }
        if (promotionData.flrValidFromUtc && promotionData.flrValidToUtc) {
            setDateRange([new Date(promotionData.flrValidFromUtc), new Date(promotionData.flrValidToUtc)])
        }
        let url: string = promotionData.flrImage || '';
/*
        switch (promotionData.imageSelection) {
            case 1:
                url = '';
                break;
            case 2:
                url = `frameImage${frameData?.fpsRecId}`;
                break;
            case 3:
                url = promotionData.flrImage ? promotionData.flrImage : `frameImage${frameData?.fpsRecId}`;
                break;
        }
        let imageSelectionForState: number;
        if (promotionData.imageSelection === 3 && !Boolean(promotionData.flrImage) && url === `frameImage${frameData?.fpsRecId}`) {
            // setImageSelectionNumber(2);
            imageSelectionForState = 2;
        } else if (!isNewPromotion && (!promotionData.imageSelection || (promotionData.imageSelection === 2 && url !== `frameImage${frameData?.fpsRecId}`))) {
            // setImageSelectionNumber(1);
            imageSelectionForState = 1;
        } else {
            // setImageSelectionNumber(promotionData.imageSelection ? promotionData.imageSelection : 3);
            imageSelectionForState = promotionData.imageSelection ? promotionData.imageSelection : 3;
        }
        if (isNewPromotion) {
            url = promotionData.flrImage ? promotionData.flrImage : `frameImage${frameData?.fpsRecId}`;
        }
*/
        setImageSrcState(url);
/*
        const data: PromoDto = {
            ...promotionData,
            imageSelection: imageSelectionForState,
        }
        setDefaultPromotionState(data);
        setPromotionState(data);
*/
        setDefaultPromotionState(promotionData);
        setPromotionState(promotionData);

        document.documentElement.addEventListener('paste', pasteImage)
        return () => {
            document.documentElement.removeEventListener('paste', pasteImage)
        }
    }, [promotionData]);

    useEffect(() => {
        setEmptyFields({
            isEmptyPromotionCaption: !Boolean(promotionState.flrCaption),
            isEmptyPromotionCode: !Boolean(promotionState.flrCode),
            // isEmptyPromotionSaleType: !Boolean(promotionData.flrSatCode)
        });
    }, [promotionState]);

    useEffect(() => {
        // setPromoCaption(getPromoCaption(promotionData, isHebrew, currencySymbol));
        const selectedSaleTypeData = saleTypes.find((saleType: SaleTypeDto) => {
            const saleTypeCode = selectedSaleType.satCode ? selectedSaleType.satCode : promotionData.flrSatCode;
            return saleType.satCode === saleTypeCode;
        });
        if (selectedSaleType.satCode) {
            const convertedPromotionFromSaleType = convertGenericPromoParamsToProperties(promotionState, selectedSaleType);
            setPromoCaption(getPromoSaleTypeCaptions(selectedSaleTypeData, currencySymbol, selectedSellingUnit, convertedPromotionFromSaleType));
            if (JSON.stringify(promotionState) !== JSON.stringify(convertedPromotionFromSaleType)) {
                setPromotionState(convertedPromotionFromSaleType);
            }
        } else {
            if (selectedSaleTypeData) {
                setPromoCaption(getPromoSaleTypeCaptions(selectedSaleTypeData, currencySymbol, selectedSellingUnit, promotionState));
            } else {
                setPromoCaption(getPromoSaleTypeCaptions(saleTypes[0], currencySymbol, selectedSellingUnit));
            }
        }
        if (!_.isEmpty(promotionState)) {
            const sellingUnitsForFlyerWithDisabledOption = sellingUnitsForFlyer?.map((sellingUnit: SellingUnitDto) => {
                return {
                    ...sellingUnit,
                    disabled: promotionState.flrSatCode !== 70 && (sellingUnit.id !== 23 && sellingUnit.id !== 1 && sellingUnit.id !== 8)
                }
            })
            setSellingUnitsState(sellingUnitsForFlyerWithDisabledOption);
        }
    }, [selectedSaleType, promotionState, selectedSellingUnit])

    //after promos&items state change
    useEffect(() => {
        setLoadingWrapper(promotionsItemsState.isLoading);
        if (promotionsItemsState.type === "UPDATE_PROMOTION_SUCCESS" || promotionsItemsState.type === "CREATE_PROMOTION_SUCCESS") {
            openPromotionModalPopup(false);
            dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
        }
    }, [promotionsItemsState.type])

    const pasteImage = (e: any) => {
        // const e = je;
        for (let i = 0; i < e.clipboardData.items.length; i++) {
            let item = e.clipboardData.items[i];
            console.log('Item: ' + item.type);
            if (item.type.indexOf('image') != -1) {
                //item.
                onFileSelected(item.getAsFile());
            } else {
                // ignore not images
                console.log('Discarding not image paste data');
            }
        }
    }

    const onFileSelected = (file: File) => {
        setImageFile(file);
    }

    const deletePromotionImage = () => {
        setImageSrcState('');
        setPromotionState({
            ...promotionState,
            flrImage: ""
        })
/*
        setPromotionState({
            ...promotionState,
            imageSelection: 1
        })
*/
        dispatch(deleteImageFromPromotion(promotionState.flrRecId!, flyerDetailsState.flyLacRec!.lacCode!));
    }

/*
    const replaceImageUsingFrameImage = () => {
        setImageSrcState(`frameImage${frameData?.fpsRecId}`);
        // promo.imageSelection = 2 (regardless of whether a Promo image exists or not, display the Frame screenshot)
        // setImageSelectionNumber(2);
        setPromotionState({
            ...promotionState,
            imageSelection: 2
        })
        console.log(frameData);
    }
*/

    const onChangePromoCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;

        setPromotionState({
            ...promotionState,
            flrCode: currentValue
        })

        if (currentValue === '') {
            setEmptyFields({
                ...emptyFields,
                isEmptyPromotionCode: true
            })
        } else {
            setEmptyFields({
                ...emptyFields,
                isEmptyPromotionCode: false
            })
        }

    }
    const onChangePromoCaption = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;

        setPromotionState({
            ...promotionState,
            flrCaption: currentValue
        })

        if (currentValue === '') {
            setEmptyFields({
                ...emptyFields,
                isEmptyPromotionCaption: true
            })
        } else {
            setEmptyFields({
                ...emptyFields,
                isEmptyPromotionCaption: false
            })
        }

    }


    const onSavePromotion = () => {
        if (isNewPromotion) {
            const currentSaleType: SaleTypeDto = selectedSaleType.satCode ? selectedSaleType : saleTypes.find((saleType: SaleTypeDto) => saleType.satCode === (selectedSaleType.satCode ? selectedSaleType.satCode : 1));
            if (currentSaleType) {
                if (!currentSaleType.benefit || !currentSaleType.requisite) {
                    const defaultValueForSelectedSaleType = saleTypesDropdownData.find(key => key.saleTypeId === currentSaleType.satCode);
                    if (defaultValueForSelectedSaleType) {
                        currentSaleType.benefit = defaultValueForSelectedSaleType.saleTypeData.defaultBenefit;
                        currentSaleType.requisite = defaultValueForSelectedSaleType.saleTypeData.defaultRequisite;
                    }
                }

                const benefitItem = promotionState?.flyerPromoItems?.find((promoItem: PromoItemsDto) => {
                    if (promoItem.fpiIsBenefit) {
                        return promoItem;
                    }
                })
                const benefitValue = benefitItem && currentSaleType.satCode === 80 ? benefitItem.fpiRecId : (selectedSaleType.benefit ? selectedSaleType.benefit : currentSaleType.benefit)
                // let convertValuesForBenefitAndRequisite = convertPromoPropertiesToGenericParams(promotionState, currentSaleType);

                const promoObjectForRequest = {
                    promoId: null,
                    flyerId: isUnlinked ? flyerDetailsState.flyRecId : null,
                    pageId: null,
                    // pageId: isUnlinked ? null : currentPage.flpRecId,
                    spotId: isUnlinked ? null : frameData?.fpsRecId,
                    code: promotionState.flrCode,
                    caption: promotionState.flrCaption,
                    displayCaption1: promotionState.flrCaption,
                    saleTypeCode: selectedSaleType.satCode ? selectedSaleType.satCode : currentSaleType.satCode,
                    requisite: selectedSaleType.requisite ? selectedSaleType.requisite : currentSaleType.requisite,
                    benefit: benefitValue,
                    // benefit: selectedSaleType.benefit ? selectedSaleType.benefit : currentSaleType.benefit,
                    keywords: "",
                    sellingUnitId: promotionState.flrSeuRecId ? promotionState.flrSeuRecId : selectedSellingUnit.id,
                    imageSelection: promotionState.imageSelection,
                    validFromUtc: promotionState.flrValidFromUtc ? promotionState.flrValidFromUtc : '',
                    validToUtc: promotionState.flrValidToUtc ? promotionState.flrValidToUtc : '',
                    // validFromUtc: dateRange[0] ? new Date(
                    //     dateRange[0].getTime() -
                    //     dateRange[0].getTimezoneOffset() * 60000
                    // ).toJSON() : '',
                    // validToUtc: dateRange[1] ? new Date(
                    //     dateRange[1].getTime() -
                    //     dateRange[1].getTimezoneOffset() * 60000
                    // ).toJSON() : '',
                    file: selectedImageFile
                }
                dispatch(createPromotion(promoObjectForRequest, flyerDetailsState?.flyLacRec?.lacCode!, imageSrcState))
            }
        } else {
            // const currentPage = flyerDetailsState.flyerPages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo -1 : selectedPageState.pageNo];
            const currentSaleType = saleTypes.find((saleType: SaleTypeDto) => saleType.satCode === promotionState.flrSatCode);
            if (currentSaleType) {
                let convertValuesForBenefitAndRequisite = convertPromoPropertiesToGenericParams(promotionState, currentSaleType);
                const benefitItem = promotionState?.flyerPromoItems?.find((promoItem: PromoItemsDto) => {
                    if (promoItem.fpiIsBenefit) {
                        return promoItem;
                    }
                })
                const benefitValue = benefitItem && currentSaleType.satCode === 80 ? benefitItem.fpiRecId : (selectedSaleType.benefit ? selectedSaleType.benefit : convertValuesForBenefitAndRequisite.benefit)
                const promoObjectForRequest = {
                    promoId: promotionState.flrRecId,
                    flyerId: isUnlinked ? flyerDetailsState.flyRecId : null,
                    pageId: null,
                    // pageId: isUnlinked ? null : currentPage.flpRecId,
                    spotId: isUnlinked ? null : frameData?.fpsRecId,
                    code: promotionState.flrCode,
                    caption: promotionState.flrCaption,
                    imageSelection: promotionState.imageSelection,
                    displayCaption1: promotionState.flrCaption,
                    saleTypeCode: selectedSaleType.satCode ? selectedSaleType.satCode : convertValuesForBenefitAndRequisite.saleTypeCode,
                    requisite: selectedSaleType.requisite ? selectedSaleType.requisite : convertValuesForBenefitAndRequisite.requisite,
                    benefit: benefitValue,
                    // benefit: selectedSaleType.benefit ? selectedSaleType.benefit : convertValuesForBenefitAndRequisite.benefit,
                    keywords: "",
                    sellingUnitId: promotionState.flrSeuRecId,
                    validFromUtc: promotionState.flrValidFromUtc,
                    validToUtc: promotionState.flrValidToUtc,
                    // validFromUtc: dateRange[0] ? new Date(
                    //     dateRange[0].getTime() -
                    //     dateRange[0].getTimezoneOffset() * 60000
                    // ).toJSON() : '',
                    // validToUtc: dateRange[1] ? new Date(
                    //     dateRange[1].getTime() -
                    //     dateRange[1].getTimezoneOffset() * 60000
                    // ).toJSON() : '',
                    file: selectedImageFile
                }
                dispatch(updatePromotion(promoObjectForRequest, flyerDetailsState?.flyLacRec?.lacCode!, imageSrcState))
            }
            //
        }
        // setLoadingWrapper(true);
    }

    const openDropdown = () => {
        if (saleTypes.length) {
            openSaleTypesDropdown(!isSaleTypesDropdownOpen);
        }
    }

    const onChangeUnit = (sellingUnit: any) => {
        setSelectedSellingUnit(sellingUnit);
        setPromotionState({
            ...promotionState,
            flrSeuRecId: sellingUnit.id
        })
    }

    const onChangeSaleType = (saleType: SaleTypeDto) => {
        setSelectedSaleType(saleType);
    }

    const compareDefaultPromoStateWithCurrentPromoState = (): boolean => {
        const stringDefaultState = JSON.stringify(defaultPromotionState);
        const stringCurrentState = JSON.stringify(promotionState);
        return stringDefaultState !== stringCurrentState;
    }

    const checkStatesBeforeLeave = () => {
        const isStateWasChanged = compareDefaultPromoStateWithCurrentPromoState();
        if (isStateWasChanged) {
            setShowConfirmExitPopup(true);
        } else {
            openPromotionModalPopup(false)
        }
    }

    const checkerBeforeSavePromoDetails = () => {
        if (
            emptyFields.isEmptyPromotionCaption || emptyFields.isEmptyPromotionCode
        ) {
            setIsRequiredFieldsNotFilled(true);
        } else {
            onSavePromotion();
        }
    };

    const onCloseWithoutSaving = () => {
        openPromotionModalPopup(false)
    }

    const confirmErrorPopup = () => {
        setIsRequiredFieldsNotFilled(false);
    }

    return (
        <>
            <Modal dialogClassName={styles.edit_add_promotion_modal} show={isShow}>
                <div className={styles.header_modal}>
                    <div className={styles.header_caption}>
                        {isNewPromotion ? 'Add Promotion' : 'Edit Promotion'}
                    </div>
                    <ClosePopupBtn onClose={checkStatesBeforeLeave}/>
                </div>
                <div className={styles.content_modal}>
                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Promotion Code
                                {/*<span>*</span>*/}
                            </div>
                            <div className={styles.input_wrapper}>
                                <input
                                    type="text"
                                    value={promotionState.flrCode}
                                    onChange={onChangePromoCode}
                                    className={`
                                ${styles.requiredField}
                                ${emptyFields.isEmptyPromotionCode ? styles.error_signal : ''}
                                `}
                                />
                                {/*{emptyFields.isEmptyPromotionCode && <div className={styles.is_required}>required field</div>}*/}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Promotion Caption
                                {/*<span>*</span>*/}
                            </div>
                            <div className={styles.input_wrapper}>
                                <input
                                    type="text"
                                    value={promotionState.flrCaption}
                                    onChange={onChangePromoCaption}
                                    className={`
                                ${styles.requiredField}
                                ${emptyFields.isEmptyPromotionCaption ? styles.error_signal : ''}
                                `}
                                />
                                {/*{emptyFields.isEmptyPromotionCaption && <div className={styles.is_required}>required field</div>}*/}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.image_content}`}>
                            {/*<div className={`${styles.image_content} ${emptyFields.isEmptySrcForImage ? styles.column_style : ''}`}>*/}
                            <div className={styles.info_for_image_wrapper}>
                                <div className={styles.caption}>
                                    Promotion Image
                                </div>
                                {
                                    imageSrcState && imageSrcState !== '' ?
                                        <ThemeProvider theme={theme}>
                                            <Tooltip
                                                enterDelay={500}
                                                enterNextDelay={500}
                                                title={<ImagePreviewPopup
                                                    src={imageSrcState}
                                                    selectedPageImage={selectedPageImage}
                                                    frame={frameData}
                                                />}
                                                placement={"right-start"}
                                            >
                                                <div className={styles.image_wrapper}>
                                                    <AsyncImageWithLoader src={imageSrcState}
                                                                          // selectedPageImage={selectedPageImage}
                                                                          // frame={frameData}
                                                                          notUploadIcon={(<NonImagePlaceholder/>)}/>
                                                </div>
                                            </Tooltip>
                                        </ThemeProvider> :
                                        <div className={styles.image_wrapper}>
                                            <AsyncImageWithLoader src={imageSrcState}
                                                                  // selectedPageImage={selectedPageImage}
                                                                  // frame={frameData}
                                                                  notUploadIcon={(<NonImagePlaceholder/>)}/>
                                        </div>
                                }
                                <div className={`${styles.upload_icon_wrapper} ${styles.images_controls}`}
                                     title={`Upload a Promo Image`}>
                                    <FileInput
                                        onFileSelected={onFileSelected}
                                        icon={(
                                            <UploadImageIcon/>
                                        )}
                                        validFileExtensions={`.jpg,.jpeg,.png`}
                                        isMultipleSelection={false}
                                        disabledAction={(promotionState.imageSelection !== 1 && imageSrcState !== '') || imageSrcState === `frameImage${frameData?.fpsRecId}`}
                                    />
                                </div>
                                <Button
                                    onClick={deletePromotionImage}
                                    className={classes.imagesButton}
                                    disabled={imageSrcState === ""}
                                    // disabled={promotionState.imageSelection === 1 || imageSrcState === ""}
                                    title={"Frame's screenshot to become the promo's image."}
                                >
                                    <DeleteImageIcon/>
                                </Button>
                                {/*<Button*/}
                                {/*    onClick={replaceImageUsingFrameImage}*/}
                                {/*    disabled={imageSrcState === `frameImage${frameData?.fpsRecId}` || (promotionState.imageSelection !== 1 && imageSrcState !== '')}*/}
                                {/*    className={classes.imagesButton}*/}
                                {/*    title={`Copy Frame's Screenshot to Promotion Image`}*/}
                                {/*>*/}
                                {/*    <FrameIcon/>*/}
                                {/*</Button>*/}
                            </div>
                            {/*{emptyFields.isEmptySrcForImage && <div className={styles.is_required}>required field</div>}*/}
                        </div>
                    </div>

                    <div className={`${styles.row_in_modal}`}>
                        <div className={`${styles.column}`} style={{width: `30%`}}>
                            <div className={styles.caption}>
                                Selling Unit
                            </div>
                            <div>
                                <Select
                                    styles={customStyles}
                                    classNamePrefix="sellingUnitSelect"
                                    value={selectedSellingUnit}
                                    onChange={onChangeUnit}
                                    getOptionValue={(option: SellingUnitDto) => option.label!}
                                    getOptionLabel={(option: SellingUnitDto) => option.label!}
                                    isSearchable={false}
                                    options={sellingUnitsState}
                                    isOptionDisabled={(option: SellingUnitDto) => option.disabled ? option.disabled : false}
                                    theme={themeSelect}
                                    isRtl={isHebrew}
                                    components={{
                                        DropdownIndicator,
                                    }}
                                />
                            </div>
                        </div>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Start/End date
                            </div>
                            <div className={styles.input_wrapper}>
                                <DatePicker
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    disabledKeyboardNavigation={true}
                                    dateFormat={"dd.MM.yyyy"}
                                    shouldCloseOnSelect={true}
                                    onChange={(update: any) => {
                                        // @ts-ignore
                                        setDateRange(update);
                                        setPromotionState({
                                            ...promotionState,
                                            flrValidFromUtc: update[0] ? new Date(
                                                update[0].getTime() -
                                                update[0].getTimezoneOffset() * 60000
                                            ).toJSON() : '',
                                            flrValidToUtc: update[1] ? new Date(
                                                update[1].getTime() -
                                                update[1].getTimezoneOffset() * 60000
                                            ).toJSON() : ''
                                        })
                                    }}
                                    // isClearable={true}
                                />
                                <div className={styles.calendar_icon_wrap}>
                                    <Calendar/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.row_in_modal} ${styles.one_columns_row}`}>
                        <div className={`${styles.column}`}>
                            <div className={styles.caption}>
                                Promo Type Caption
                                {/*<span>*</span>*/}
                            </div>
                            <div className={styles.input_wrapper}>
                                <div title={convertedPromoCaption}
                                     className={`${styles.div_button_like_input} ${isHebrew ? styles.hebrew_fake_row : ''}`}
                                     onClick={() => {
                                         openDropdown();
                                     }}>
                                    <span>{convertedPromoCaption}</span>
                                    <Box>
                                        <DropdownIcon/>
                                    </Box>
                                </div>
                                {/*{*/}
                                {/*    emptyFields.isEmptyPromotionCaption && <div className={styles.is_required}>required field</div>*/}
                                {/*}*/}
                                {
                                    isSaleTypesDropdownOpen && <PromosSaleTypesPopup
                                        currentPromoSaleTypeCode={promotionData.flrSatCode!}
                                        saleTypesArray={saleTypes}
                                        selectedSaleType={selectedSaleType}
                                        setSelectedSaleType={onChangeSaleType}
                                        openSaleTypesDropdown={openSaleTypesDropdown}
                                        promotionState={promotionState}
                                        defaultPromotionState={defaultPromotionState}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.footer_modal}>
                    <div
                        className={`${styles.save_wrap}`}>
                        <OrangeButton buttonName={'SAVE'}
                                      isDisabled={JSON.stringify(emptyFields).indexOf('true') > -1 || !compareDefaultPromoStateWithCurrentPromoState()}
                                      onClick={onSavePromotion}/>
                    </div>
                </div>
                {
                    isLoading && <div className={styles.isLoading}>
                        <PageSpinner/>
                    </div>
                }

            </Modal>
            {isShowConfirmExitPopup && (
                <SimpleConfirmPopup
                    onClose={setShowConfirmExitPopup}
                    contentText={`Save changes?`}
                    onConfirm={checkerBeforeSavePromoDetails}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={onCloseWithoutSaving}
                />
            )}
            {isRequiredFieldsNotFilled && (
                <SimpleConfirmPopup
                    onClose={setIsRequiredFieldsNotFilled}
                    contentText={`Required fields are not filled.
Please fill them in and try saving again.`}
                    onConfirm={confirmErrorPopup}
                    buttonText={[`OK`]}
                />
            )}

        </>
    )
}